module.exports = __webpack_public_path__ + "img/portada-blog.95e66164.jpg";